import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import reducer from './reducers';
import thunk from 'redux-thunk';
import { getIsDirty } from './reducers/dirty';
import $ from 'jquery';
import { fetchFormSuccessAction, refreshErrorsAction } from './actions/form';
import dotProp from 'dot-prop-immutable';
import { update } from './api';
import { success, error } from 'plugins/toastr';
import { bindModal } from '../common/modals/index';

const formatInteger = propName => (form, errors) => {
  const value = dotProp.get(form, propName);
  if (!!value) {
    if (!isNaN(value) && Number.isInteger(Number(value))) {
      return {
        form: dotProp.set(form, propName, Number(value)),
        errors: errors,
      };
    } else {
      errors.push(propName);
      return {
        form: form,
        errors: errors,
      };
    }
  } else {
    return {
      form: dotProp.set(form, propName, undefined),
      errors: errors,
    };
  }
};

const formatDecimal = (propName, isRequired) => (form, errors) => {
  const value = dotProp.get(form, propName);
  if (!!value) {
    if (!isNaN(value)) {
      return {
        form: dotProp.set(form, propName, Number(value).toFixed(2)),
        errors: errors,
      };
    } else {
      errors.push(propName);
      return {
        form: form,
        errors: errors,
      };
    }
  } else {
    if (isRequired) {
      errors.push(propName);
    }

    return {
      form: dotProp.set(form, propName, undefined),
      errors: errors,
    };
  }
};

const validateForm = form => {
  const formatters = [
    formatInteger('form.zone.constructionDate'),
    formatInteger('form.zone.numberOfFloors'),
    formatDecimal('form.zone.buildingSurface', true),
    formatDecimal('form.zone.buildingPerimeter', false),
    formatDecimal('form.zone.landSurface', true),
    formatDecimal('form.zone.landPerimeter', false),
  ];

  return formatters.reduce(
    (acc, format) => {
      return format(acc.form, acc.errors);
    },
    { form: form, errors: [] }
  );
};

export function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('root');
  const caseId = root.getAttribute('data-case');
  const customerId = root.getAttribute('data-customer');
  const caseStatus = root.getAttribute('data-case-status');
  const store = createStore(
    reducer,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#root form').addClass('dirty');
    }
  };

  bindModal();

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page
        caseId={parseInt(caseId, 10)}
        customerId={parseInt(customerId, 10)}
        caseStatus={caseStatus}
      />
    </Provider>,
    root
  );

  const cleanDirty = () => $('#root form').removeClass('dirty');

  const saveButton = document.getElementById('bt-save');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    saveButton.onclick = () => {
      const validationResult = validateForm(store.getState().form);
      const { errors } = validationResult;

      store.dispatch(refreshErrorsAction(errors));
      if (errors.length === 0) {
        cleanDirty();
        update(id, validationResult.form.form)
          .then(res => res.json())
          .then(
            response => {
              success('Chantier enregistré avec succès');
              store.dispatch(fetchFormSuccessAction(response));
            },
            err => {
              console.debug(err);
              if (err.res.status === 409) {
                err.res.text().then(message => error(message));
              } else {
                error('Une erreur est survenue pendant la sauvegarde ');
              }
            }
          );
      } else {
        error('Des champs sont manquants ou en erreur dans le formulaire.');
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/index.js